// extracted by mini-css-extract-plugin
module.exports = {"list":"NoticeList_list__3QeHK","loading":"NoticeList_loading__TSGQf"};